import { render, staticRenderFns } from "./PersonalDataFormFields.vue?vue&type=template&id=3a211222&scoped=true"
import script from "./PersonalDataFormFields.vue?vue&type=script&lang=ts"
export * from "./PersonalDataFormFields.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDataFormFields.vue?vue&type=style&index=0&id=3a211222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a211222",
  null
  
)

export default component.exports